import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Container, Nav, Navbar, Row, Col, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { IoLocationOutline, IoCallOutline } from "react-icons/io5";
import {
  MdOutlinePhoneAndroid,
  MdOutlineDashboard,
  MdHealthAndSafety,
} from "react-icons/md";
import { IoHome } from "react-icons/io5";
import { ImPriceTag } from "react-icons/im";
import { RiContactsFill } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
const AppBar = () => {
  return (
    <>
      <>
        <div className="mark-bg">
          <div className="d-lg-block d-none">
            <Container fluid>
              <Row className="py-2">
                <Col
                  lg="4"
                  xs="4"
                  sm="4"
                  className="align-self-center d-lg-block d-none"
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={require("../../assets/images/gpay.png")}
                        className="img-fluid gpay"
                        alt="gpay"
                      />
                    </div>
                    <div className="text-white">
                      <h5 className="bold mt-2 mx-2">86102 14826</h5>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center text-white">
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={50}
                    delay={9}
                  >
                    | Whatsapp : +91 86102 14826 | Mobile No : +91 95669 02788 | Email : seeni382@gmail.com
                  </Marquee>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="d-lg-none d-block py-3">
            <Container fluid>
              <Row>
                <Col xs="4" sm="4">
                  <a href="https://wa.me/918610214826?text=Hello%20King%20Of%20Amaran%20Crackers">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/whatsappicon.webp")}
                        className="img-fluid"
                        alt="whatsapp"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="tel:+918610214826">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/callicon.webp")}
                        className="img-fluid"
                        alt="call"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="https://maps.app.goo.gl/uWdtNrHZ3uE1bAx8A" target="_blank" rel="noreferrer">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/googlelocation.png")}
                        className="img-fluid"
                        alt="location"
                      />
                    </div>
                  </a>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </>
      <>
        {/* <div  className='navv-bg bg-overlay'>
        <Container className='py-3 z'>
            <Row>
              <Col lg='4' md='12' xs="12">
                <Navbar.Brand href="/">
                  <div className='logo mx-auto'>
                    <img src={require('../../assets/images/storelogo.png')} className='img-fluid' alt='product name' />
                  </div>
              </Navbar.Brand>
              </Col>
              <Col lg='4' className='align-self-center d-lg-block d-none'>
                <div className='d-flex justify-content-center '>
                    <div></div>
                    <div>
                      <h5 className='bold'> Address</h5>
                      <p className='regular'> 3/1362/30 Bharathi Nagar, Sivakamipuram Colony, <br/>
                      Sivakasi - 626189
                      </p>
                    </div>
                </div>
              </Col>
              <Col lg='4' className='align-self-center d-lg-block d-none'>
                <div className='d-flex justify-content-center '>
                    <div></div>
                    <div class>
                      <h5 className='bold'> Mobile Number</h5>
                        <div className='regular'>
                          <li>+91 9003885080</li>
                          <li>+91 9944726077</li>
                        </div>
                    </div>
                </div>
              </Col>
            </Row>
        </Container>
      </div> */}
      </>

      <>
        <Navbar expand="lg" className=" headnav">
          <Container fluid className="px-lg-5">
            <Navbar.Brand href="/">
              <div className="logo mx-auto">
                <img
                  src={require("../../assets/images/logosm.png")}
                  className="img-fluid"
                  alt="product name"
                />
              </div>
            </Navbar.Brand>
            <div className="mx-auto">
              <Navbar.Toggle aria-controls="basic-navbar-nav mx-auto text-center py-3" />
            </div>

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto text-center py-3">
                <Nav.Link as={NavLink} exact to={"/"}>
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/about"}>
                  About
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/products"}>
                  Pricelist
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/safetytips"}>
                  Safety Tips
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/contactus"}>
                  Contact
                </Nav.Link>
                {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
              </Nav>
              {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    </>
  );
};
const AppBarTwo = () => {
  return (
    <>
      <>
        <div className="mark-bg">
          <div className="d-lg-block d-none">
            <Container fluid>
              <Row className="py-2">
                <Col
                  lg="4"
                  xs="4"
                  sm="4"
                  className="align-self-center d-lg-block d-none"
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={require("../../assets/images/gpay.png")}
                        className="img-fluid gpay"
                        alt="gpay"
                      />
                    </div>
                    <div className="text-white">
                      <h5 className="bold mt-2 mx-2">86102 14826</h5>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center text-white">
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={50}
                    delay={9}
                  >
                    Whatsapp : +91 86102 14826 | Mobile No : +91 95669 02788 | Email : seeni382@gmail.com
                  </Marquee>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="d-lg-none d-block py-3">
            <Container fluid>
              <Row>
                <Col xs="4" sm="4">
                  <a href="https://wa.me/918610214826?text=Hello%20King%20Of%20Amaran%20Crackers">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/whatsappicon.webp")}
                        className="img-fluid"
                        alt="whatsapp"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="tel:+918610214826">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/callicon.webp")}
                        className="img-fluid"
                        alt="call"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="https://maps.app.goo.gl/uWdtNrHZ3uE1bAx8A" target="_blank" rel="noreferrer">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/googlelocation.png")}
                        className="img-fluid"
                        alt="product name"
                      />
                    </div>
                  </a>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </>
      <>
        <div className="navlink-bg">
          <Container className="py-3 z">
            <Row>
              <Col lg="4" md="12" xs="12">
                <Navbar.Brand href="/">
                  <div className="logo mx-auto">
                    <img
                      src={require("../../assets/sivasakthicrackersimage/download.png")}
                      className="img-fluid"
                      alt="product name"
                    />
                  </div>
                </Navbar.Brand>
              </Col>
              <Col lg="4" className="align-self-center d-lg-block d-none">
                <div className="d-flex justify-content-center ">
                  <div className="me-3">
                    <IoLocationOutline size={45} color="white" />
                  </div>
                  <div>
                    <h5 className="bold text-white"> Address</h5>
                    <p className="regular text-white">
                      {" "}
                      Mettamalai, Sattur to Sivakasi Main Road
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg="4" className="align-self-center d-lg-block d-none">
                <div className="d-flex justify-content-center ">
                  <div className="me-3">
                    <MdOutlinePhoneAndroid size={45} color="white" />
                  </div>
                  <div class>
                    <h5 className="bold text-white"> Mobile Number</h5>
                    <div className="regular text-white">
                      <li>+91 96264 44988</li>
                      <li>+91 97877 08980</li>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>

      <>
        <Navbar expand="lg" className="nav-pad nav-bg">
          <Container className="px-lg-5">
            <div className="mx-auto">
              <Navbar.Toggle aria-controls="basic-navbar-nav mx-auto text-center py-3" />
            </div>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto text-center">
                <Nav.Link as={NavLink} exact to={"/"}>
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/about"}>
                  About
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/products"}>
                  Pricelist
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/safetytips"}>
                  Safety Tips
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/contactus"}>
                  Contact
                </Nav.Link>
                {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
              </Nav>
              {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    </>
  );
};
const AppBarThree = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);

  const handleShow = (app) => {
    setSelectedApp(app);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedApp(null);
  };

  const qrCodes = {
    gpay: require("../../assets/images/gpay.png"),
    phonepe: require("../../assets/images/phonepae.jpeg"),
  };
  return (
    <>
      <>
        <div className="mark-bg">
          <div className="d-lg-block d-none">
            <Container fluid>
              <Row className="py-0">
                <Col
                  lg="4"
                  xs="4"
                  sm="4"
                  className="align-self-center d-lg-block d-none"
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={require("../../assets/images/Gpay.jpg")}
                        alt="GPay"
                        style={{
                          width: "50px",
                          cursor: "pointer",
                          borderRadius: "50px",
                          marginRight: "10px",
                        }}
                        onClick={() => handleShow("gpay")}
                      />

                      <img
                        src={require("../../assets/images/Phonepay.png")}
                        alt="PhonePe"
                        style={{
                          width: "50px",
                          cursor: "pointer",
                          borderRadius: "50px",
                        }}
                        onClick={() => handleShow("phonepe")}
                      />
                    </div>
                    <>
                      <Modal show={showModal} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                          {selectedApp === "gpay" && "GPay QR Code"}
                          {selectedApp === "phonepe" && "PhonePe QR Code"}
                        </Modal.Header>
                        <Modal.Body
                          className="text-center"
                          style={{ height: "450px" }}
                        >
                          {selectedApp && qrCodes[selectedApp] && (
                            <img
                              src={qrCodes[selectedApp]}
                              alt={`${selectedApp} QR`}
                              style={{ width: "100%", height: "400px" }}
                            />
                          )}
                          ;
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center">
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                    <div className=" d-lg-block d-none ">
                      <h5 className="bold mt-2 mx-2">86102 14826 / 95669 02788</h5>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center ">
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={50}
                    delay={9}
                  >
                    💥 "கிங் ஆஃப் அமரன் கிராக்கர்ஸ் - KING OF AMARAN CRACKERS (Group of Sathya Crackers World)! அனைத்து வகை பட்டாசுகளும் சிறந்த தரம் & நேரடி ஆலை விலையில்!" 🎆
                    தீபாவளிக்கு சிறப்பு சலுகைகள்! நேரடி ஆர்டருக்கு: (86102 14826 / 95669 02788)
                  </Marquee>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <>
          <div
            className="d-lg-none d-block py-3 align-self-center"
            style={{
              backgroundColor: "#feba17",
            }}
          >
            <Container
              fluid
              className="d-flex "
              style={{
                width: "100%",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <a href="https://wa.me/918940655143?text=Hello Sri Senthur Murugan fireworks">
                <div className="mob-icon mx-auto">
                  <img
                    src={require("../../assets/images/whatsappicon.webp")}
                    className="img-fluid"
                    alt="product name"
                  />
                </div>
              </a> */}

              <div className="d-flex align-items-center">
                <div>
                  <Row style={{ width: "100vw" }}>
                    <Col
                      xs={4}
                      sm={4}
                      className="d-flex justify-content-start align-items-center"
                    >
                      <div style={{ marginRight: "10px" }}>
                        <img
                          src={require("../../assets/images/Gpay.jpg")}
                          alt="GPay"
                          className="img-fluid"
                          style={{
                            width: "60px",
                            cursor: "pointer",
                            borderRadius: "50px",
                          }}
                          onClick={() => handleShow("gpay")}
                        />
                      </div>
                    </Col>
                    <Col
                      xs={4}
                      sm={4}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <div
                        style={{
                          fontSize: "17px",
                          fontWeight: "bold",
                          color: "black",
                        }}
                      >
                        96264 44988 / 97877 08980
                      </div>
                    </Col>
                    <Col
                      xs={4}
                      sm={4}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <div style={{ marginLeft: "10px" }}>
                        <img
                          src={require("../../assets/images/Phonepay.png")}
                          alt="PhonePe"
                          className="img-fluid"
                          style={{
                            width: "60px",
                            cursor: "pointer",
                            borderRadius: "50px",
                          }}
                          onClick={() => handleShow("phonepe")}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <>
                  <Modal show={showModal} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                      {selectedApp === "gpay" && "GPay QR Code"}
                      {selectedApp === "phonepe" && "PhonePe QR Code"}
                    </Modal.Header>
                    <Modal.Body
                      className="text-center"
                      style={{ height: "450px" }}
                    >
                      {selectedApp && qrCodes[selectedApp] && (
                        <img
                          src={qrCodes[selectedApp]}
                          alt={`${selectedApp} QR`}
                          style={{ width: "100%", height: "400px" }}
                        />
                      )}
                      ;
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              </div>

              {/*<Col xs="4" sm="4">
                  <a href="tel:+918940655143">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/callicon.webp")}
                        className="img-fluid"
                        alt="product name"
                      />
                    </div>
                  </a>
                </Col>*/}
              {/*<Col xs="4" sm="4">
                  <a href="https://maps.app.goo.gl/A66cTebzzfAq56QdA" alt="">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/googlelocation.png")}
                        className="img-fluid"
                        alt="product name"
                      />
                    </div>
                  </a>
                </Col>*/}
            </Container>
          </div>
        </>
        <>
          <div className="bg-img bg-overlay">
            <Container fluid className="py-3 z">
              <Row>
                <Col lg="2" className="text-center">
                  <div className="mx-3 ">
                    <img
                      style={{
                        width: "150px",
                      }}
                      src={require("../../assets/images/Logo_updated-01.png")}
                      alt="company-logo"
                    />
                  </div>
                </Col>
                <Col lg="4">
                  <Navbar.Brand href="/">
                    <div className="logo company-name-head  mt-3">
                      <h2 className="logo-head-ft">
                        KING OF AMARAN CRACKERS
                        <br />
                      </h2>
                      <hr className="logo-head-ul" />
                      <h6 className="logo-head-sd">
                        Best Quality Crackers @ Whole Sale Price
                      </h6>
                    </div>
                  </Navbar.Brand>
                </Col>
                <Col lg="6" className="d-lg-block d-none py-5">
                  <Navbar expand="lg" className="nav-bg">
                    <Container>
                      <div>
                        <Navbar.Toggle aria-controls="basic-navbar-nav  text-center " />
                      </div>
                      <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className=" text-center">
                          <Nav.Link as={NavLink} exact to={"/home"}>
                            Home
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/about"}>
                            About
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/"}>
                            Pricelist
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/safetytips"}>
                            Safety Tips
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/contactus"}>
                            Contact
                          </Nav.Link>
                          {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
                        </Nav>
                        {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
                      </Navbar.Collapse>
                    </Container>
                  </Navbar>
                </Col>
              </Row>
            </Container>
          </div>
        </>

        <>
          <Navbar className="nav-pad nav-bg d-lg-none d-block fixed-bottom">
            <Container className="px-lg-5">
              <div className="mx-auto">
                <Navbar.Toggle aria-controls="basic-navbar-nav mx-auto text-center py-3" />
              </div>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto text-center">
                  <Nav.Link
                    as={NavLink}
                    exact
                    to={"/home"}
                    className="margin-20"
                  >
                    <IoHome />
                    Home
                  </Nav.Link>
                  {/* <Nav.Link as={NavLink} exact to={"/about"} className='margin-20'><MdOutlineDashboard />About</Nav.Link> */}
                  <Nav.Link as={NavLink} exact to={"/"} className="margin-20">
                    <ImPriceTag />
                    Pricelist
                  </Nav.Link>
                  {/* <Nav.Link as={NavLink} exact to={"/safetytips"} className='margin-20'><MdHealthAndSafety />Safety Tips</Nav.Link> */}
                  <Nav.Link
                    as={NavLink}
                    exact
                    to={"/contactus"}
                    className="margin-20"
                  >
                    <RiContactsFill />
                    Contact
                  </Nav.Link>
                  {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
                </Nav>
                {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      </>
    </>
  );
};
const AppBarFour = () => {
  const mapLink =
    "https://maps.app.goo.gl/uWdtNrHZ3uE1bAx8A";

  return (
    <>
      {/* 1. Top Ribbon Marquee Strip */}
      <div
        className="top-ribbon-bar py-1 d-none d-lg-block"
        style={{
          background: "linear-gradient(90deg, #0B132B 0%, #1E1B4B 50%, #0B132B 100%)",
          borderBottom: "2px solid #FFD700",
          color: "#FFF8F0",
          fontSize: "0.85rem",
        }}
      >
        <Container fluid className="px-lg-4">
          <Row className="align-items-center g-0">
            <Col lg={4} className="d-flex align-items-center gap-2">
              <span
                className="badge px-2.5 py-1 text-dark fw-bold"
                style={{
                  background: "linear-gradient(135deg, #FFD700 0%, #F59E0B 100%)",
                  borderRadius: "20px",
                  fontSize: "0.75rem",
                }}
              >
                ✨ SIVAKASI DIRECT OUTLET
              </span>
              <span style={{ color: "#FDE68A", fontSize: "0.82rem", fontWeight: "600" }}>
                Wholesale & Retail Fireworks
              </span>
            </Col>

            <Col lg={5} className="text-center overflow-hidden">
              <Marquee pauseOnHover={true} direction="left" speed={45}>
                💥 கிங் ஆஃப் அமரன் கிராக்கர்ஸ் - KING OF AMARAN CRACKERS (Group of Sathya Crackers World)! 88% நேரடி கம்பனி தள்ளுபடி விற்பனை! 🎆 நேரடி ஆர்டருக்கு: 86102 14826 / 95669 02788
              </Marquee>
            </Col>

            <Col lg={3} className="text-end d-flex justify-content-end align-items-center gap-3">
              <a
                href="https://wa.me/918610214826?text=Hello%20King%20Of%20Amaran%20Crackers"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none fw-bold"
                style={{ color: "#25D366", fontSize: "0.82rem" }}
              >
                <FaWhatsapp size={15} className="me-1" />
                86102 14826
              </a>
              <span style={{ color: "#F59E0B" }}>|</span>
              <a
                href="tel:+918610214826"
                className="text-decoration-none fw-bold text-white"
                style={{ fontSize: "0.82rem" }}
              >
                <IoCallOutline size={15} className="me-1" />
                86102 14826
              </a>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mobile Top Marquee */}
      <div
        className="top-ribbon-bar py-1 d-block d-lg-none"
        style={{
          background: "linear-gradient(90deg, #0B132B 0%, #1E1B4B 100%)",
          borderBottom: "1px solid #FFD700",
          color: "#FFF8F0",
          fontSize: "0.8rem",
        }}
      >
        <Marquee pauseOnHover={true} direction="left" speed={45}>
          💥 கிங் ஆஃப் அமரன் கிராக்கர்ஸ்! KING OF AMARAN CRACKERS (Group of Sathya Crackers World)! 88% நேரடி தள்ளுபடி! ஆர்டருக்கு: 86102 14826 / 95669 02788
        </Marquee>
      </div>

      {/* 2. Main Desktop Header Bay - Fresh Luxury Pattern */}
      <div
        className="brand-main-header d-none d-lg-block py-3 position-relative"
        style={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)",
          borderBottom: "2px solid #001FBE",
          boxShadow: "0 4px 15px rgba(0, 31, 190, 0.06)",
        }}
      >
        <Container className="px-lg-4">
          <Row className="align-items-center">
            {/* Left: Brand Identity with 3D Circular Logo */}
            <Col lg={7} className="d-flex align-items-center gap-3">
              <a href="/" className="text-decoration-none flex-shrink-0">
                <div
                  className="rounded-circle p-1 bg-white"
                  style={{
                    width: "110px",
                    height: "110px",
                    border: "3px solid #001FBE",
                    boxShadow: "0 6px 20px rgba(0, 31, 190, 0.22)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <img
                    src={require("../../assets/images/Logo_updated-01.png")}
                    alt="KING OF AMARAN CRACKERS Logo"
                    className="w-100 h-100 rounded-circle object-fit-contain"
                  />
                </div>
              </a>
              <div>
                <h1
                  className="bold mb-1"
                  style={{
                    color: "#0B132B",
                    fontSize: "1.85rem",
                    letterSpacing: "0.5px",
                    fontFamily: "serif",
                    lineHeight: "1.1",
                  }}
                >
                  KING OF AMARAN CRACKERS
                </h1>
                <div
                  className="fw-bold mb-1"
                  style={{
                    color: "#B45309",
                    fontSize: "0.96rem",
                    letterSpacing: "0.3px",
                  }}
                >
                  Group of Sathya Crackers World | Wholesale & Retail | 88% Discount
                </div>
                <div className="d-flex align-items-center gap-1 text-secondary" style={{ fontSize: "0.85rem" }}>
                  <IoLocationOutline size={16} color="#001FBE" />
                  <span>148E, Sivakasi - Virudhunagar Main Road, Nethaji Nagar, Veera Chelliya Puram, Virudhunagar - 626 001</span>
                </div>
              </div>
            </Col>

            {/* Right: Quick Action Cards */}
            <Col lg={5}>
              <div className="d-flex justify-content-end gap-3">
                {/* Store Location Card */}
                <a
                  href={mapLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                  style={{ minWidth: "175px" }}
                >
                  <div
                    className="p-2.5 px-3 rounded-3 d-flex align-items-center gap-2 h-100"
                    style={{
                      background: "#FFFFFF",
                      border: "1.5px solid #001FBE",
                      boxShadow: "0 3px 10px rgba(0, 31, 190, 0.12)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "38px",
                        height: "38px",
                        background: "linear-gradient(135deg, #001FBE 0%, #0B132B 100%)",
                        color: "#FFD700",
                      }}
                    >
                      <IoLocationOutline size={20} />
                    </div>
                    <div>
                      <div className="fw-bold" style={{ color: "#001FBE", fontSize: "0.76rem" }}>
                        STORE OUTLET
                      </div>
                      <div className="fw-bold text-dark" style={{ fontSize: "0.82rem" }}>
                        Nethaji Nagar, Virudhunagar
                      </div>
                    </div>
                  </div>
                </a>

                {/* Direct Call Card */}
                <div
                  className="p-2.5 px-3 rounded-3 d-flex align-items-center gap-2"
                  style={{
                    background: "#FFFFFF",
                    border: "1.5px solid #001FBE",
                    boxShadow: "0 3px 10px rgba(0, 31, 190, 0.12)",
                    minWidth: "185px",
                  }}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "38px",
                      height: "38px",
                      background: "linear-gradient(135deg, #001FBE 0%, #0B132B 100%)",
                      color: "#FFD700",
                    }}
                  >
                    <IoCallOutline size={20} />
                  </div>
                  <div>
                    <div className="fw-bold" style={{ color: "#001FBE", fontSize: "0.76rem" }}>
                      ORDER HELPLINE
                    </div>
                    <div className="fw-bold" style={{ fontSize: "0.82rem", lineHeight: "1.3" }}>
                      <a href="tel:+918610214826" style={{ color: "#1F2937", textDecoration: "none" }}>
                        86102 14826
                      </a>
                      <br />
                      <a href="tel:+919566902788" style={{ color: "#1F2937", textDecoration: "none" }}>
                        95669 02788
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mobile Header Bay - Distinct Mobile Pattern */}
      <div
        className="d-lg-none d-block px-3 py-3"
        style={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)",
          borderBottom: "2px solid #001FBE",
        }}
      >
        <Container>
          <div className="d-flex align-items-center gap-2 mb-3">
            <a href="/" className="flex-shrink-0">
              <img
                src={require("../../assets/images/Logo_updated-01.png")}
                alt="KING OF AMARAN CRACKERS Logo"
                style={{
                  width: "75px",
                  height: "75px",
                  borderRadius: "50%",
                  border: "2.5px solid #001FBE",
                  boxShadow: "0 4px 12px rgba(0, 31, 190, 0.18)",
                }}
              />
            </a>
            <div className="flex-grow-1">
              <h2
                className="bold mb-0"
                style={{ color: "#0B132B", fontSize: "1.15rem", fontFamily: "serif" }}
              >
                KING OF AMARAN CRACKERS
              </h2>
              <div className="fw-bold" style={{ color: "#B45309", fontSize: "0.76rem" }}>
                Group of Sathya Crackers World | Wholesale & Retail
              </div>
              <div className="text-secondary" style={{ fontSize: "0.74rem" }}>
                📍 Nethaji Nagar, Virudhunagar
              </div>
            </div>
          </div>

          {/* Quick Action Touch Pills (Call, WhatsApp, Map) */}
          <Row className="g-2 mb-1">
            <Col xs={4}>
              <a
                href="tel:+918610214826"
                className="btn w-100 py-1.5 px-1 d-flex flex-column align-items-center justify-content-center text-decoration-none"
                style={{
                  background: "#001FBE",
                  color: "#FFD700",
                  borderRadius: "10px",
                  border: "1px solid #FFD700",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                }}
              >
                <IoCallOutline size={16} className="mb-0.5" />
                Call
              </a>
            </Col>
            <Col xs={4}>
              <a
                href="https://wa.me/918610214826?text=Hello%20King%20Of%20Amaran%20Crackers"
                target="_blank"
                rel="noreferrer"
                className="btn w-100 py-1.5 px-1 d-flex flex-column align-items-center justify-content-center text-decoration-none"
                style={{
                  background: "#25D366",
                  color: "#FFFFFF",
                  borderRadius: "10px",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                }}
              >
                <FaWhatsapp size={16} className="mb-0.5" />
                WhatsApp
              </a>
            </Col>
            <Col xs={4}>
              <a
                href={mapLink}
                target="_blank"
                rel="noreferrer"
                className="btn w-100 py-1.5 px-1 d-flex flex-column align-items-center justify-content-center text-decoration-none"
                style={{
                  background: "linear-gradient(135deg, #FFD700 0%, #F59E0B 100%)",
                  color: "#0B132B",
                  borderRadius: "10px",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                }}
              >
                <IoLocationOutline size={16} className="mb-0.5" />
                Map
              </a>
            </Col>
          </Row>
        </Container>
      </div>

      {/* 3. Golden Flame Curved Navbar */}
      <Navbar
        expand="lg"
        className="py-1"
        collapseOnSelect
        style={{
          background: "linear-gradient(90deg, #0B132B 0%, #001FBE 50%, #0B132B 100%)",
          borderBottom: "3px solid #FFD700",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Container>
          {/* Mobile Menu Toggle Button */}
          <div className="w-100 d-flex justify-content-center d-lg-none my-1">
            <Navbar.Toggle
              aria-controls="mobile-navbar-nav"
              className="border-0 w-100 py-2"
              style={{
                background: "linear-gradient(135deg, #FFD700 0%, #F59E0B 100%)",
                color: "#0B132B",
                fontWeight: "900",
                borderRadius: "25px",
                boxShadow: "0 4px 15px rgba(245, 158, 11, 0.4)",
                border: "2px solid #FFD700",
                maxWidth: "96%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "1.05rem", color: "#0B132B" }}>
                ☰ MENU & PRODUCTS
              </span>
            </Navbar.Toggle>
          </div>

          <Navbar.Collapse id="mobile-navbar-nav">
            <Nav className="me-auto text-center py-2 w-100 justify-content-center align-items-center gap-lg-2">
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/home"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                Home
              </Nav.Link>
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/about"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                className="px-4 py-2 my-1 my-lg-0 fw-bold"
                as={NavLink}
                exact
                to={"/"}
                style={{
                  background: "linear-gradient(135deg, #FFD700 0%, #F59E0B 100%)",
                  color: "#0B132B",
                  borderRadius: "25px",
                  boxShadow: "0 0 15px rgba(255, 215, 0, 0.6)",
                  border: "2px solid #FFF",
                  fontSize: "1rem",
                  letterSpacing: "0.5px",
                }}
              >
                💥 Price List 2026 💥
              </Nav.Link>
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/safetytips"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                Safety Tips
              </Nav.Link>
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/contactus"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};


export { AppBar, AppBarTwo, AppBarThree, AppBarFour };
